// import { pipe } from 'ramda';
import Gallery from './modules/gallery';
import Aos from './modules/aos';
import Header from './modules/header';
import lazyLoad from './modules/lazyLoad';
// import parallax from './modules/parallax';
import responsiveBg from './modules/responsiveBg';
import TabSlider from './modules/tab-slider';
import Slider from './modules/slider';

// pipe(Gallery, Header, lazyLoad, responsiveBg, parallax, TabSlider)();
Aos();
Gallery();
Header();
lazyLoad();
responsiveBg();
TabSlider();
Slider();
// 26.2107243,-81.6888462

const forms = document.querySelectorAll(`form`);

if (forms.length > 0) {
    const searchParams = new URLSearchParams(window.location.search);

    forms.forEach((form) => {
        if (searchParams.size > 0) {
            for (const param of searchParams) {
                const input = form.querySelector(
                    `.populate_query_${param[0]} input`
                );

                if (input) {
                    input.setAttribute('value', param[1]);
                }
            }
        }
    });
}
